'use client';

// Funding / backers pill under the landing hero headline.
//
import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { JSX, ReactNode } from 'react';
const BACKER_LINK_CLASS = 'pointer-events-auto no-underline transition-colors duration-fast hover:text-foreground-brand' as const;

// A pill that wraps stops reading as a pill, so the line is held to one at
// every width: `whitespace-nowrap` is the guarantee, and the copy plus the
// smaller phone type size are what keep it inside the viewport. Measured in
// GeistSans, the line needs 238px at `text-caption` and 278px at `text-body`,
// against 248px of inner width on a 320px screen and 552px at `sm`.
const PILL_CLASS = 'max-w-2xl whitespace-nowrap rounded-full border border-border-primary bg-background-secondary/70 px-5 py-3 text-caption font-medium leading-relaxed text-foreground-secondary backdrop-blur-sm sm:text-body' as const;
const RAISE_AMOUNT = '$2.5M' as const;
function BackerLink(t0) {
  const $ = _c(3);
  const {
    href,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== href) {
    t1 = <a href={href} target="_blank" rel="noopener noreferrer" className={BACKER_LINK_CLASS}>{children}</a>;
    $[0] = children;
    $[1] = href;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function HeroBackersPill() {
  const $ = _c(4);
  const t = useTranslations("supportMainnet.hero");
  let t0;
  if ($[0] !== t) {
    t0 = t.rich("backers", {
      amount: RAISE_AMOUNT,
      pharsalus: _temp,
      yellow: _temp2,
      solana: _temp3
    });
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <p className={PILL_CLASS} data-testid="hero-backers-pill">{t0}</p>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp3(chunks_1) {
  return <BackerLink href="https://www.solanalabs.com/">{chunks_1}</BackerLink>;
}
function _temp2(chunks_0) {
  return <BackerLink href="https://yellow.vc/">{chunks_0}</BackerLink>;
}
function _temp(chunks) {
  return <BackerLink href="https://pharsalus.com/">{chunks}</BackerLink>;
}